export default __webpack_public_path__ + "static/media/02.3faa18ad.jpg";